<template>
  <loading v-if="loading" />
  <Wrapper v-if="patient.done === false">
    <div>
      <p>病歷號</p>
      <br />
      <input
        v-model="patient.info.patientNo"
        type="text"
        size="30"
        maxlength="7"
        style=" font-size: 16px; border:1px; border-bottom-style: solid;border-top-style: none;border-left-style:none;border-right-style:none;"
      />
      <br />
      <br />
      <input
        v-if="member.platform === 'pad'"
        type="submit"
        @click.prevent="padFirstVisit"
        class="submitBtn"
        value="確認送出"
      />
      <input
        v-else-if="member.platform === 'musoon'"
        type="submit"
        @click.prevent="musoonFirstVisit"
        class="submitBtn"
        value="確認送出"
      />
    </div>
  </Wrapper>
  <Content
    v-else
    @submit="formSubmit"
    :patient="patient"
    :platform="member.platform"
  ></Content>
  <modal v-if="modal.display" @close="closeModal">
    <template #header>{{ modal.header }}</template>
    <template #body>{{ modal.body }}</template>
  </modal>
  <debug v-if="debug">{{ member }}</debug>
</template>

<script>
import Content from "../components/Form/Content.vue";
import Wrapper from "../components/Form/Wrapper.vue";
export default {
  components: {
    Content,
    Wrapper
  },
  data() {
    return {
      debug: eval(process.env.VUE_APP_DEBUG),
      loading: true,
      modal: {},
      patient: {
        info: {},
        originForm: null,
        done: false
      }
    };
  }, //data
  computed: {
    member() {
      return this.$store.state.member;
    }
  },
  mounted() {
    if (this.member.params.patientNo) {
      this.patient.info.patientNo = this.member.params.patientNo;
      this.musoonFirstVisit();
    }
    if (this.member.platform === "develop" || this.member.platform === "line") {
      this.lineDevelopFirstVisit();
      this.patient.info = this.member.info;
    }

    this.loading = false;
  },
  methods: {
    closeModal() {
      if (this.modal.type === "fail") {
        this.modal.display = false;
        return;
      }

      if (
        this.member.platform === "develop" ||
        this.member.platform === "line"
      ) {
        this.$router.replace("/Homepage");
        return;
      }

      if (this.member.platform === "pad" || this.member.platform === "musoon") {
        this.patient.done = false;
        this.patient.info.patientNo = "";
      }

      this.modal.display = false;
    },

    formSubmit(data) {
      this.$http
        .post("/api/mobile/FirstVisitForm", {
          action: "set",
          data: data.form,
          member: data.form.patientNo,
          jwt: this.member.jwt
        })
        .then(response => {
          console.log(response.data.code);
          if (response.data.code !== "success") {
            this.modal = {
              type: "fail",
              display: true,
              header: "儲存失敗",
              body: "請再次送出。"
            };
            return;
          }

          if (this.member.platform === "musoon") {
            this.modal = {
              display: true,
              header: null,
              body: "儲存完畢"
            };
            return;
          }

          this.modal = {
            display: true,
            header: "感謝您的耐心填寫",
            body: "我們已收到您的初診問診單，請等候問診通知。"
          };
        })
        .catch(error => {
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    },

    padFirstVisit() {
      if (
        isNaN(this.patient.info.patientNo) ||
        this.patient.info.patientNo.length < 7
      ) {
        this.modal = {
          display: true,
          header: "錯誤",
          body: "病歷號小於7碼或是含有非數字"
        };
        return;
      }

      this.$http
        .post("/api/mobile/FirstVisitForm", {
          action: "get",
          patientNo: this.patient.info.patientNo,
          jwt: this.member.jwt
        })
        .then(response => {
          console.log(response.data);

          if (response.data.code === "forbidden") {
            this.modal = {
              display: true,
              header: "錯誤",
              body: response.data.message
            };

            return;
          }

          if (response.data.code === "success") {
            this.modal = {
              display: true,
              header: "錯誤",
              body: "此病歷號已存在"
            };

            return;
          }

          this.patient.nameEditable = true;
          this.patient.done = true;
        })
        .catch(error => {
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    },

    musoonFirstVisit() {
      console.log(this.patient.info.patientNo);
      this.$http
        .post("/api/mobile/FirstVisitForm", {
          action: "get",
          patientNo: this.patient.info.patientNo,
          jwt: this.member.jwt
        })
        .then(response => {
          console.log(response.data);

          if (response.data.code === "forbidden") {
            this.modal = {
              display: true,
              header: "錯誤",
              body: response.data.message
            };

            return;
          }

          if (response.data.code === "success") {
            this.patient.originForm = response.data.form;
            this.patient.done = true;

            return;
          }

          this.modal = {
            display: true,
            header: "錯誤",
            body: "查無此病歷號"
          };
        })
        .catch(error => {
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    },

    lineDevelopFirstVisit() {
      this.$http
        .post("/api/mobile/FirstVisitForm", {
          action: "get",
          patientNo: this.member.info.patientNo,
          jwt: this.member.jwt
        })
        .then(response => {
          console.log(response.data);
          if (response.data.code === "success") {
            this.modal = {
              display: true,
              header: null,
              body: "您已填寫過初診單，謝謝。"
            };

            this.patient.disableContent = true;
            this.patient.done = true;

            return;
          }

          this.patient.disableContent = false;
          this.patient.done = true;
        })
        .catch(error => {
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    }
  }
};
</script>
